import { parseMoneyInput } from "../utils/priceFormat";
import { apiRequest } from "./apiClient";
import { createActivity, getActivityActor } from "./activityService";
import { emitRestDataChanged } from "./restEventBus";
import { trackEngagementDataAdded } from "./engagementService";
import { recordMeaningfulReviewAction } from "./appReviewService";

const enc = (v) => encodeURIComponent(String(v || ""));

export const finanslariGetirService = async (familyId, type = null) => {
  if (!familyId) return [];

  if (type) {
    const data = await apiRequest(`/finance/${enc(familyId)}?type=${enc(type)}`);
    return Array.isArray(data?.items) ? data.items : [];
  }

  // Finance backend tek tablo kullanıyor; ana gelir/gider servisi araç kayıtlarını karıştırmamalı.
  const [incomeData, expenseData] = await Promise.all([
    apiRequest(`/finance/${enc(familyId)}?type=income`),
    apiRequest(`/finance/${enc(familyId)}?type=expense`),
  ]);
  const items = [
    ...(Array.isArray(incomeData?.items) ? incomeData.items : []),
    ...(Array.isArray(expenseData?.items) ? expenseData.items : []),
  ];
  return items.sort((a, b) => new Date(b.tarih || b.createdAt || 0) - new Date(a.tarih || a.createdAt || 0));
};

export const finansEkleService = async ({
  familyId,
  finansBaslik,
  finansTutar,
  finansTur,
  finansKategori,
  finansTarih,
  tamAd,
  profilAvatar = null,
  user,
  paraBirimi = "TRY",
  recurrence = null,
}) => {
  const payload = {
    itemType: finansTur === "Gelir" ? "income" : "expense",
    baslik: finansBaslik,
    tutar: parseMoneyInput(finansTutar),
    tur: finansTur,
    kategori: finansKategori,
    tarih: finansTarih,
    ekleyen: tamAd,
    ekleyenUid: user?.uid,
    createdByUid: user?.uid,
    ortakHarcama: false,
    createdAt: new Date().toISOString(),
    paraBirimi,
    ...(recurrence?.enabled ? { recurrence } : {}),
  };

  const data = await apiRequest(`/finance/${enc(familyId)}`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  const item = data?.item || payload;
  const id = item?.id || item?.firebaseId;
  trackEngagementDataAdded({ familyId, moduleKey: "finance", itemId: id });
  void recordMeaningfulReviewAction(user?.uid, {
    trigger: "finance_created",
    moduleKey: "finance",
    itemId: id,
  }).catch(() => {});
  emitRestDataChanged({ familyId, resource: "finance", action: "added", item });

  await createActivity({
    familyId,
    type: "finance_added",
    category: "finance",
    actor: getActivityActor({ user, name: tamAd, avatar: profilAvatar }),
    payload: { title: finansBaslik, amount: payload.tutar, kind: finansTur, category: finansKategori, date: finansTarih },
    targetPage: "finans",
    targetId: id,
  });

  return id;
};

export const finansSilService = async ({ familyId, finansId, finans, user, tamAd, profilAvatar = null, scope = "current" }) => {
  await apiRequest(`/finance/${enc(familyId)}/${enc(finansId)}?scope=${enc(scope)}`, { method: "DELETE" });
  emitRestDataChanged({ familyId, resource: "finance", action: "deleted", itemId: finansId });

  await createActivity({
    familyId,
    type: "finance_deleted",
    category: "finance",
    actor: getActivityActor({ user, name: tamAd, avatar: profilAvatar }),
    payload: { title: finans?.baslik || finans?.ad || "", amount: finans?.tutar || "" },
    targetPage: "finans",
    targetId: finansId,
  });
};
